export default __webpack_public_path__ + "static/media/Hydra_Logo_Black.f9fe2188.png";